// Двухфазный флоу входа cabinet-app: email → /check-email → пароль/ссылка/заявка.
// С модерацией регистрации новый email не логинится сразу, а подаёт заявку
// (POST /register, status=pending) — админ одобряет в панели.

export interface CheckEmailResult {
  exists: boolean
  has_password: boolean
  status?: string | null // pending | active | rejected; отсутствует для нового
}

export type LoginStep = 'password' | 'magic-link' | 'register' | 'pending' | 'rejected'

/**
 * По ответу /api/v1/auth/check-email решает следующий шаг:
 *  - нет строки (новый) → 'register' (форма-заявка);
 *  - status='pending'   → 'pending' (заявка на рассмотрении);
 *  - status='rejected'  → 'rejected' (отклонена);
 *  - активный с паролем → 'password'; активный без пароля → 'magic-link'.
 *
 * Зарубежный НОВЫЙ email до этой функции не доходит: /check-email отдаёт 403
 * (406-ФЗ), который обрабатывается на слое fetch отдельным сообщением.
 */
export function decideLoginStep(result: CheckEmailResult): LoginStep {
  if (!result.exists) return 'register'
  if (result.status === 'pending') return 'pending'
  if (result.status === 'rejected') return 'rejected'
  return result.has_password ? 'password' : 'magic-link'
}
